<div class="detail-content">
  @if (item(); as currentItem) {
    <div class="feedback-panel">
      <div class="feedback-panel__left">
        <div class="feedback-meta-row">
          <span class="feedback-timestamp">
            Created {{ getCreatedLabel() }}@if (item()?.updatedDate) { - Updated {{ getUpdatedLabel() }}}
          </span>
        </div>
        <span class="feedback-note">
          <i class="pi pi-sparkles"></i>
          Generated by AI - verify sources before acting.
        </span>
      </div>

    </div>

    <ng-template #feedbackControls>
      <span class="feedback-label">Leave feedback</span>
      <div class="feedback-actions">
        <button
          #positiveFeedbackButton
          type="button"
          class="feedback-btn"
          aria-label="Give positive feedback"
          title="Give positive feedback"
          (click)="onFeedback('up')">
          <i class="pi pi-thumbs-up" aria-hidden="true"></i>
        </button>
        <button
          #negativeFeedbackButton
          type="button"
          class="feedback-btn"
          aria-label="Give negative feedback"
          title="Give negative feedback"
          (click)="onFeedback('down')">
          <i class="pi pi-thumbs-down" aria-hidden="true"></i>
        </button>
      </div>
    </ng-template>

    @if (currentItem.persistedCase; as persisted) {
      <app-persisted-case-detail [header]="persisted" [payload]="currentItem.casePayload" [error]="loadingSettled() ? currentItem.caseDetailError : undefined"
        [hasWorkflow]="hasUc2Workflow()" [workflowTabBadge]="workflowTabBadge()"
        [requestedTab]="requestedTab()" (tabSelected)="tabSelected.emit($event)">
        <div headerFeedback class="header-feedback">
          <ng-container [ngTemplateOutlet]="feedbackControls"></ng-container>
        </div>
        <app-detail-comments
          [comments]="comments()"
          [draft]="commentDraft()"
          [posting]="savingComment()"
          (draftChanged)="onCommentInput($event)"
          (posted)="saveComment()"
          caseComments />
        @if (currentItem.linkedEngineCaseId; as linkedCaseId) {
          <div engineWorkflow [hidden]="!workflowContentReady()">
            <app-well-exception-live-workflow [caseId]="linkedCaseId" />
          </div>
        }
      </app-persisted-case-detail>
    } @else if (currentItem.engineCaseId; as engineCaseId) {
      <div [hidden]="!workflowContentReady()">
      @if (currentItem.identity?.useCase === 'UC2') {
        <app-well-exception-live-workflow [caseId]="engineCaseId" />
      } @else {
        <app-engine-case-detail [caseId]="engineCaseId" />
      }
      </div>
    } @else {

    @let feedbackInHeader = isProductionDeviation() || currentItem.identity?.useCase === 'UC2';
    <div class="detail-card">
      <app-detail-header
        [item]="currentItem"
        [summaryBlocks]="summaryBlocks()"
        [summaryText]="summaryText()"
        [previewAssetCodes]="previewAssetCodes()">
        @if (feedbackInHeader) {
          <div headerFeedback class="header-feedback">
            <ng-container [ngTemplateOutlet]="feedbackControls"></ng-container>
          </div>
        }
      </app-detail-header>
      <div class="detail-card-body">
        <app-detail-steps
          [itemId]="currentItem.id"
          [steps]="currentItem.steps"
          [uc1Candidates]="currentItem.uc1Candidates"
          [uc1Evidence]="currentItem.uc1Evidence"
          [summaryText]="summaryText()"
          [recommendedActions]="recommendedActions()"
          [sourceLines]="recommendedActionSources()"
          [comments]="comments()"
          [commentsOpen]="commentsOpen()"
          [commentDraft]="commentDraft()"
          [commentPosting]="savingComment()"
          [hasDecision]="!!decidedStep() || hasEngineWorkflow() || currentItem.id.startsWith('case-')"
          [isClosed]="isClosed()"
          [hasEngineWorkflow]="hasEngineWorkflow()"
          [isProductionDeviation]="isProductionDeviation()"
          [workflowTabBadge]="workflowTabBadge()"
          [requestedTab]="requestedTab() ?? (isProductionDeviation() ? 'candidates' : null)"
          (tabSelected)="tabSelected.emit($event)"
          (approve)="approve.emit()"
          (reject)="onReject()"
          (addComment)="openCommentModal()"
          (toggleComments)="toggleComments()"
          (commentDraftChanged)="onCommentInput($event)"
          (commentPosted)="saveComment()">
          @if (!feedbackInHeader) {
            <div summaryFeedback class="feedback-panel__right">
              <ng-container [ngTemplateOutlet]="feedbackControls"></ng-container>
            </div>
          }
          @if (linkedProductionDeviationCaseId(); as linkedCaseId) {
            <div engineWorkflow [hidden]="!workflowContentReady()">
              <app-production-deviation-workflow [item]="currentItem" [engineCaseId]="linkedCaseId" />
            </div>
          } @else if (linkedEngineCaseId(); as linkedCaseId) {
            <div engineWorkflow [hidden]="!workflowContentReady()">
              <app-engine-case-detail [caseId]="linkedCaseId" />
            </div>
          }
        </app-detail-steps>
      </div>
    </div>

    <app-detail-comment-modal
      [open]="commentModalOpen()"
      [draft]="commentDraft()"
      [saving]="savingComment()"
      [error]="commentError()"
      (closed)="closeCommentModal()"
      (draftChanged)="onCommentInput($event)"
      (saveRequested)="saveComment()" />

    <app-detail-reject-modal
      [open]="rejectModalOpen()"
      [draft]="rejectDraft()"
      (closed)="closeRejectModal()"
      (draftChanged)="onRejectInput($event)"
      (confirmRequested)="confirmReject()" />

    }

    <app-detail-feedback-modal
      [open]="feedbackModalOpen()"
      [feedbackType]="feedbackType()"
      [feedbackReasons]="feedbackReasons()"
      [selectedReasons]="selectedFeedbackReasons()"
      [feedbackComment]="feedbackComment()"
      [submitting]="submittingFeedback()"
      [error]="feedbackError()"
      (closed)="closeFeedbackModal()"
      (reasonToggled)="toggleFeedbackReason($event)"
      (commentChanged)="onFeedbackCommentInput($event)"
      (submitRequested)="submitFeedback()" />
  } @else {
    <div class="empty-state">
      <p>Select an item from the inbox to view details.</p>
    </div>
  }
</div>
